<template>
  <modal
    :title="setModel != undefined ? 'Update Provider' : 'Add Provider'"
    @close="$emit('close')"
  >
    <template #content>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem row"
        ref="form"
      >
        <div class="col-12">
          <formGroup
            :title="'Name'"
            v-model="model.Name"
            :errors="errors"
            :rules="{ required: true, max: 50 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Link'"
            v-model.number="model.Link"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'PdfConverter'"
            :as="'select'"
            v-model="model.PdfConverter"
            :errors="errors"
          >
            <template #input>
              <option :value="null"></option>
              <option :value="'phantomjs'">phantomjs</option>
              <option :value="'puppeteer'">puppeteer</option>
            </template>
          </formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'CaptchaService'"
            v-model="model.CaptchaService"
            :as="'select'"
            :errors="errors"
            @keydown.enter="save"
          >
            <template #input>
              <option :value="null"></option>
              <option :value="'capsolver'">capsolver</option>
              <option :value="'2captcha'">2captcha</option>
              <option :value="'capmonster'">capmonster</option>
              <option :value="'24captcha'">24captcha</option>
              <option :value="'brightdata'">brightdata</option>
              <option :value="'solvecaptcha'">solvecaptcha</option>
              <option :value="'multibot'">multibot</option>
              <option :value="'hcaptchasolver'">hcaptchasolver</option>
              <option :value="'anysolver'">anysolver</option>
              <option :value="'manual'">manual</option>
            </template></formGroup
          >
        </div>
        <div class="col-6">
          <formGroup
            :title="'Interval'"
            v-model.number="model.Interval"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'OutputPort'"
            v-model.number="model.OutputPort"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'P1'"
            v-model="model.P1"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'P2'"
            v-model="model.P2"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'P3'"
            v-model="model.P3"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'RedisTTL'"
            v-model.number="model.RedisTTL"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'WorkingStatus'"
            :as="'select'"
            v-model="model.WorkingStatus"
            :errors="errors"
          >
            <template #input>
              <option :value="null"></option>
              <option value="1">Normal</option>
              <option value="2">Yavaş</option>
            </template>
          </formGroup>
        </div>
        <div class="col-12">
          <div class="card proxy" style="overflow:hidden">
            <div class="card-header">
              <formGroup
                :title="'Static Proxy'"
                :as="'checkbox'"
                v-model="model.StaticProxy"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.StaticProxy">
              <div class="row">
                <div class="col-6">
                  <formGroup
                    :title="'Proxy IP'"
                    type="text"
                    v-model="model.ProxyIP"
                    :rules="{ required: true }"
                    :max="model.ProxyIP"
                    :errors="errors"
                    @keydown.enter="save"
                  ></formGroup>
                </div>
                <div class="col-6">
                  <formGroup
                    :title="'Proxy Port'"
                    type="number"
                    v-model.number="model.ProxyPort"
                    :rules="{ required: true }"
                    :min="model.ProxyPort"
                    :errors="errors"
                    @keydown.enter="save"
                  ></formGroup>
                </div>
                <div class="col-6">
                  <formGroup
                    :title="'Proxy Username'"
                    type="text"
                    v-model="model.ProxyUsername"
                    :rules="{ required: true }"
                    :min="model.ProxyPort"
                    :errors="errors"
                    @keydown.enter="save"
                  ></formGroup>
                </div>
                <div class="col-6">
                  <formGroup
                    :title="'Proxy Password'"
                    type="text"
                    v-model="model.ProxyPassword"
                    :rules="{ required: true }"
                    :min="model.ProxyPort"
                    :errors="errors"
                    @keydown.enter="save"
                  ></formGroup>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <formGroup
            :title="'Load'"
            :as="'checkbox'"
            v-model="model.Load"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'State'"
            :as="'checkbox'"
            v-model="model.State"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'Confirm'"
            :as="'checkbox'"
            v-model="model.Confirm"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'Notconfirm'"
            :as="'checkbox'"
            v-model="model.Notconfirm"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'Download'"
            :as="'checkbox'"
            v-model="model.Download"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'TourPrice'"
            :as="'checkbox'"
            v-model="model.TourPrice"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'NotedConfirm'"
            :as="'checkbox'"
            v-model="model.NotedConfirm"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'IsMailProvider'"
            :as="'checkbox'"
            v-model="model.IsMailProvider"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'DailyEnterExit'"
            :as="'checkbox'"
            v-model="model.DailyEnterExit"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'AgencyConfirmRequired'"
            :as="'checkbox'"
            v-model="model.AgencyConfirmRequired"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'DetailContentToPdf'"
            :as="'checkbox'"
            v-model="model.DetailContentToPdf"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'OnlyDayTime'"
            :as="'checkbox'"
            v-model="model.OnlyDayTime"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'AuthRequired'"
            :as="'checkbox'"
            v-model="model.AuthRequired"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'Unvisible'"
            :as="'checkbox'"
            v-model="model.Unvisible"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'CCMailConfirm'"
            :as="'checkbox'"
            v-model="model.CCMailConfirm"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'FromMailConfirm'"
            :as="'checkbox'"
            v-model="model.FromMailConfirm"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'ConfirmationLinkRequired'"
            :as="'checkbox'"
            v-model="model.ConfirmationLinkRequired"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'EmailAuthRequired'"
            :as="'checkbox'"
            v-model="model.EmailAuthRequired"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'SMSAuthRequired'"
            :as="'checkbox'"
            v-model="model.SMSAuthRequired"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'Stopped'"
            :as="'checkbox'"
            v-model="model.Stopped"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'AutoSave'"
            :as="'checkbox'"
            v-model="model.AutoSave"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'OnTest'"
            :as="'checkbox'"
            v-model="model.OnTest"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'ConfirmStatus'"
            :as="'checkbox'"
            v-model="model.ConfirmStatus"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'DocumentStatus'"
            :as="'checkbox'"
            v-model="model.DocumentStatus"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process">{{
        setModel != undefined ? "Update Provider" : "Add Provider"
      }}</Btn>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    setModel: Object,
  },
  data() {
    return {
      model: {
        Id: null,
        Name: "",
        Load: true,
        State: false,
        Confirm: false,
        Notconfirm: false,
        Download: false,
        TourPrice: false,
        NotedConfirm: false,
        OutputPort: 0,
        Link: null,
        IsMailProvider: false,
        PdfConverter: "phantomjs",
        Interval: 1200,
        DailyEnterExit: false,
        AgencyConfirmRequired: false,
        DetailContentToPdf: false,
        OnlyDayTime: false,
        AuthRequired: false,
        Unvisible: false,
        CCMailConfirm: false,
        FromMailConfirm: false,
        ConfirmationLinkRequired: false,
        Stopped: false,
        CaptchaService: "",
        EmailAuthRequired: false,
        SMSAuthRequired: false,

        StaticProxy: false,
        ProxyIP: "",
        ProxyPort: "",
        ProxyUsername: "",
        ProxyPassword: "",

        AutoSave: false,

        P1:null,
        P2:null,
        P3:null,

        RedisTTL: null,
        OnTest: null,
        WorkingStatus: null,
        ConfirmStatus: null,
        DocumentStatus: null
      },
      errs: {},
      process: false,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
      // WorkingStatus select'i string option kullaniyor; edit'te sayi gelirse
      // dogru secenek secili gelsin diye string'e cevir (save'de int'e geri doner).
      if (this.model.WorkingStatus != null) {
        this.model.WorkingStatus = String(this.model.WorkingStatus);
      }
    }
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          // formGroup select/input degeri string emit ediyor; sayisal alanlari
          // backend'e INT (veya null) olarak yolla.
          const payload = { ...this.model };
          payload.WorkingStatus =
            payload.WorkingStatus === null || payload.WorkingStatus === ""
              ? null
              : parseInt(payload.WorkingStatus, 10);
          payload.RedisTTL =
            payload.RedisTTL === null || payload.RedisTTL === ""
              ? null
              : parseInt(payload.RedisTTL, 10);
          this.$appAxiosAdmin
            .post(`KOLAYREZ/Providers`, payload)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "Provider has been successfully updated."
                    : "Provider has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.proxy .collapse {
  padding: 0 20px 2px;
}
.proxy .row {
  margin: 0 -5px;
}
.proxy .row > div {
  padding: 0 5px;
}
</style>
